import React from "react";
import { Trans } from 'react-i18next';
import useSound from "use-sound";
import clickSound from "../../sound/warning.mp3"
import {
    Heading,
    Line,
    Button,
    Link,
    Words,
    SoundsProvider,
    createSounds
} from 'arwes';




const sounds = {
  shared: { volume: 1 },
    players: {
      information: {
          sound: {
              src: ['../../public/assets/sound/click.mp3']
          }
      }
    }
}




const Header = () => {

    
    return (

             <div style={{margin: 0}}>
                    <nav className="navbar navbar-expand-lg ">
                            <a className="navbar-brand" href="/"> <Heading>Sci-Fi News</Heading></a>
                            <Button animate className="navbar-toggler ml-auto" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                    aria-expanded="false" aria-label="Toggle navigation">
                                <i className='mdi mdi-chemical-weapon'/> Menu

                            </Button>
                        <div className="collapse navbar-collapse w-100 order-3 dual-collapse2" id="navbarSupportedContent">
                            <ul className="navbar-nav ml-auto">
                                <li id="click" className="nav-item">
                                  <Link

                                      style={{paddingLeft: 20, textDecoration: "none"}} href="/news">
                                      <Trans>News</Trans>
                                  </Link>
                                </li>

                                <li className="nav-item">
                                    <Link style={{paddingLeft: 20, textDecoration: "none"}} href="/category"><Trans>Categories</Trans></Link>
                                </li>

                                <li className="nav-item">
                                    <Link style={{paddingLeft: 20, textDecoration: "none"}} href="/blog"><Trans>Blog</Trans></Link>
                                </li>
                                <li className="nav-item">
                                    <Link style={{paddingLeft: 20, textDecoration: "none"}} href="/signup"><Trans>Sign Up</Trans></Link>
                                </li>


                            </ul>
                        </div>
                    </nav>
                 <Line/>
            </div>


        )

}



export default Header
